import React, { useEffect, useMemo, useState } from 'react';
import MenuItem from '@mui/material/MenuItem';

import MDTypography from 'components/MDTypography';
import MDSelect from 'components/MDSelect';

import { Section } from './Section';
import { activitiesApi } from 'sectors/pilates/settings/activities/activitiesApi';

export function ActivityOnlySection({ sx, tokens, activityId, setActivityId, onItemsLoaded }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    let alive = true;
    async function load() {
      setLoading(true);
      setIsError(false);
      try {
        const res = await activitiesApi.list();
        const arr = Array.isArray(res) ? res : res?.items || [];
        if (!alive) return;

        const safe = Array.isArray(arr) ? arr : [];
        setItems(safe);
        onItemsLoaded?.(safe);

        if (!activityId && safe[0]?.id != null) {
          setActivityId(String(safe[0].id));
        }
      } catch (e) {
        if (!alive) return;
        setIsError(true);
        setItems([]);
        onItemsLoaded?.([]);
      } finally {
        if (!alive) return;
        setLoading(false);
      }
    }
    load();
    return () => (alive = false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const label = useMemo(() => {
    const a = items.find((x) => String(x.id) === String(activityId));
    return a?.name || '';
  }, [items, activityId]);

  return (
    <Section title="Hizmet" icon="fitness_center" sx={sx}>
      <MDTypography variant="caption" sx={{ opacity: 0.75, fontWeight: 700, mb: 0.6 }}>
        Aktivite
      </MDTypography>

      <MDSelect
        value={activityId || ''}
        onChange={(e) => setActivityId(String(e.target.value))}
        fullWidth
        sx={tokens.select}
        renderValue={(val) => (val ? label : <em>Aktivite seç</em>)}
      >
        {loading ? (
          <MenuItem value="" disabled>
            <em>Yükleniyor…</em>
          </MenuItem>
        ) : isError ? (
          <MenuItem value="" disabled>
            <em>Aktiviteler yüklenemedi</em>
          </MenuItem>
        ) : (
          (Array.isArray(items) ? items : []).map((a) => (
            <MenuItem key={a.id} value={String(a.id)}>
              {a.name}
            </MenuItem>
          ))
        )}
      </MDSelect>
    </Section>
  );
}
